import React from 'react';

import { useDeps } from 'src/hooks/useDeps';
import { currentUrl } from 'src/util/currentUrl';

import { useReviews } from './ReviewsContext';

type ReviewsProps = {
    id: string | number;
    price: string;
    currency: 'GBP' | 'USD' | 'EUR';
    name: string;
    url: string;
    imageUrl: string | undefined;
};

export function Reviews(props: ReviewsProps) {
    const { DOMAIN } = useDeps().env;
    const url = currentUrl(DOMAIN || '', `/${props.url}`);
    const { id, price, currency, name, imageUrl } = props;
    useReviews();
    return (
        <div
            className="yotpo yotpo-main-widget"
            data-product-id={id}
            data-price={price}
            data-currency={currency}
            data-name={name}
            data-url={url}
            data-image-url={imageUrl}
        />
    );
}
